'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookTheme = require('@narvar/nth-hook-theme');
var React = require('react');
var uuid = require('uuid');

const toKebab = key => key.replace(/([a-z\d])([A-Z])/g, '$1-$2').toLowerCase();
const styleObjectToString = s => Object.entries(s).reduce((accum, [key, value]) => {
  return `${toKebab(key)}:${value};${accum}`;
}, '');
function useHackStyle() {
  const cssClass = 'descriptionStyleHack';
  const styleRef = React.useRef(uuid.v4());
  const {
    linksNoneDefault: link,
    linksNoneHover: hover
  } = nthHookTheme.useTheme();
  const generateStyle = React.useCallback(() => {
    const linkStyle = link ? `.${cssClass} a { ${styleObjectToString(link)}}` : '';
    const linkHoverStyle = hover ? `.${cssClass} a:hover { ${styleObjectToString(hover)}}` : '';
    return [linkStyle, linkHoverStyle].join('');
  }, [link, hover]);
  React.useEffect(() => {
    const exisitingStyleTag = document.getElementById(styleRef.current);
    if (exisitingStyleTag) return;
    const styleTag = document.createElement('style');
    const styling = generateStyle();
    document.head.appendChild(styleTag);
    styleTag.setAttribute('id', styleRef.current);
    styleTag.appendChild(document.createTextNode(styling));
  }, [generateStyle]);
  return {
    cssClass
  };
}

exports.useHackStyle = useHackStyle;
